import { render, staticRenderFns } from "./setup.vue?vue&type=template&id=e8b150f8&scoped=true"
import script from "./setup.vue?vue&type=script&lang=js"
export * from "./setup.vue?vue&type=script&lang=js"
import style0 from "./setup.vue?vue&type=style&index=0&id=e8b150f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b150f8",
  null
  
)

export default component.exports